import {
  GroupedPermissions,
  Permission,
  PermissionQueryParams,
} from '../models/permissions.model';
import { apiService } from './api.service';

/**
 * Permission Service
 * Handles all permission-related API calls
 */
class PermissionService {
  private baseUrl = '/permissions';

  /**
   * Get all permissions
   */
  async getAll(params?: PermissionQueryParams): Promise<Permission[]> {
    return apiService.get<Permission[]>(this.baseUrl, {
      params,
    });
  }

  /**
   * Get permissions grouped by category
   */
  async getAllGrouped(
    params?: PermissionQueryParams
  ): Promise<GroupedPermissions[]> {
    return apiService.get<GroupedPermissions[]>(`${this.baseUrl}/grouped`, {
      params,
    });
  }

  /**
   * Get a single permission by ID
   */
  async getById(id: string): Promise<Permission> {
    return apiService.get<Permission>(`${this.baseUrl}/${id}`);
  }

  /**
   * Get all unique categories
   */
  async getCategories(): Promise<string[]> {
    return apiService.get<string[]>(`${this.baseUrl}/meta/categories`);
  }

  /**
   * Get all unique modules
   */
  async getModules(): Promise<string[]> {
    return apiService.get<string[]>(`${this.baseUrl}/meta/modules`);
  }
}

export const permissionService = new PermissionService();
